import AppRoutes from "./routes";
import CartModal from "./components/Cart/CartModal";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import { CookieProvider } from "./context/CookieContext";
import GTMConsentHandler from "./components/GTMConsentHandler";
import { PopupProvider } from "./context/PopupContext";
import PopupMenu from "./components/PopupMenu/PopupMenu";
import { PopupFormProvider } from "./context/PopupFormContext";
import PopupForm from "./components/PopupForm/PopupForm";
import ClarityAnalytics from "./components/ClarityAnalytics";
import DynamicMetaTags from "./components/Dynamicmetatags";
import FloatingCallButton from "./components/FloatingCallButton/FloatingCallButton";

const App = () => {
  return (
    <PopupProvider>
      <PopupFormProvider>
        <CookieProvider>
          {/* ❌ ВИДАЛИТИ CartProvider звідси - він вже в main.tsx */}
          <AppRoutes /> {/* Ваші маршрути */}
          <CartModal />
          <CookieBanner />
          <PopupMenu />
          <PopupForm />
          <FloatingCallButton />
          <ClarityAnalytics />
          <DynamicMetaTags />
          <GTMConsentHandler />
        </CookieProvider>
      </PopupFormProvider>
    </PopupProvider>
  );
};

export default App;
